var map = {
	"./campfire.mp3": 3259,
	"./forest.mp3": 3260,
	"./ocean.mp3": 3261,
	"./river.mp3": 3262,
	"./savanna.mp3": 3263,
	"./storm.mp3": 3264
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background .\.mp3*
// module id = 383
// module chunks = 0